import { render, staticRenderFns } from "./CatalogProductList.vue?vue&type=template&id=4d5f18c2&scoped=true&"
import script from "./CatalogProductList.vue?vue&type=script&lang=js&"
export * from "./CatalogProductList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductList.vue?vue&type=style&index=0&id=4d5f18c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f18c2",
  null
  
)

export default component.exports